module.exports = __webpack_public_path__ + "img/aboutUs_img12.9137ea82.svg";